var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentationChartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66663 3.33333C1.66663 2.8731 2.03972 2.5 2.49996 2.5H17.5C17.9602 2.5 18.3333 2.8731 18.3333 3.33333C18.3333 3.79357 17.9602 4.16667 17.5 4.16667V13.3333C17.5 14.2538 16.7538 15 15.8333 15H12.0118L13.9225 16.9107C14.248 17.2362 14.248 17.7638 13.9225 18.0893C13.5971 18.4147 13.0695 18.4147 12.744 18.0893L9.99996 15.3452L7.25588 18.0893C6.93045 18.4147 6.40281 18.4147 6.07737 18.0893C5.75193 17.7638 5.75193 17.2362 6.07737 16.9107L7.98811 15H4.16663C3.24615 15 2.49996 14.2538 2.49996 13.3333V4.16667C2.03972 4.16667 1.66663 3.79357 1.66663 3.33333ZM4.16663 4.16667V13.3333H9.99938C9.99977 13.3333 10.0002 13.3333 10.0005 13.3333H15.8333V4.16667H4.16663ZM14.7559 6.07741C15.0813 6.40285 15.0813 6.93049 14.7559 7.25592L11.4225 10.5893C11.0971 10.9147 10.5695 10.9147 10.244 10.5893L8.33329 8.67851L6.42255 10.5893C6.09711 10.9147 5.56947 10.9147 5.24404 10.5893C4.9186 10.2638 4.9186 9.73618 5.24404 9.41074L7.74404 6.91074C8.06947 6.58531 8.59711 6.58531 8.92255 6.91074L10.8333 8.82149L13.5774 6.07741C13.9028 5.75197 14.4304 5.75197 14.7559 6.07741Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationChartLine);
export default __webpack_public_path__ + "static/media/presentation-chart-line.fbd84e2142808d45be649be21056d8f6.svg";
export { ForwardRef as ReactComponent };